import React from "react";

export default function AdminPanel() {
  return (
    <div className="p-6 bg-white rounded-2xl shadow-md">
      <h2 className="text-2xl font-semibold mb-2">Admin Panel</h2>
      <p>Welcome to the Admin section.</p>
    </div>
  );
}
